<template>
  <main>
    <section class="fk-contents">
      <h2 class="title-lv2 mb10">{{text.InputTableNumber}}</h2>
      <h3 class="title-lv3 mb20"> </h3>

      <div class="mod-form-block">
        <span class="label">{{text.TableNumber}}</span>
        <input type="number" name="tableNumber" id="tableNumber" v-model="model.tableNumber">
        <span class="validation-error" v-if="errors.tableNumber !== null">{{errors.tableNumber}}</span>
      </div>

      <p class="mod-form-btn"><a href="#" class="btn-base btn-sub" @click.prevent="execDetermination()">{{text.SpecificationTable}}</a></p>
    </section>
  </main>
</template>

<script>
import CommonMixin from '@/mixins/CommonMixin'
import ValidationMixin from '@/mixins/ValidationMixin'
export default {
  name: 'FKMOTableOrderInput',
  data () {
    return {
      text: {
        SpecificationHeading: null,
        InputTableNumber: null,
        TableNumber: null,
        SpecificationTable: null
      },
      model: {
        tableNumber: null
      },
      errors: {
        tableNumber: null
      }
    }
  },
  mixins: [ CommonMixin, ValidationMixin ],
  computed: {
    getOrderDetail () {
      return this.$store.getters.orderDetail
    }
  },
  methods: {
    execDetermination: function () {
      const validation = this.validTableNumber(this.model.tableNumber)
      this.errors.tableNumber = validation.errors.tableNumber
      if (!validation.isValid) {
        return false
      }

      // 注文明細にテーブル番号をセットする
      const orderDetail = this.getOrderDetail
      orderDetail.tableNumber = this.model.tableNumber
      this.$store.commit('setOrderDetail', orderDetail)

      this.$router.push({ name: 'TableOrderConfirm' })
    },
    initView: function () {
      // マウント後に画面出力する文字列を設定する
      this.text.InputTableNumber = this.$i18n.t('ReceiveMethod.InputTableNumber')
      this.text.TableNumber = this.$i18n.t('ReceiveMethod.TableNumber')
      this.text.SpecificationTable = this.$i18n.t('ReceiveMethod.SpecificationTable')
    },
    init: function () {
      // 初期化処理
      // テーブル番号をモデルにセットする
      this.model.tableNumber = this.getOrderDetail.tableNumber
    }
  },
  beforeMount () {
    this.init()
  },
  mounted () {
    this.initView()
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>

<style scoped>
.validation-error {
  color: #f00;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/TableOrderInput.vue